import { atom } from "jotai";

export const statsValues = atom<any | null>(null);
